import React from "react";

import { Layout, Menu, Row, Col, Button } from "antd";
import {
  GlobalOutlined,
  PhoneOutlined,
  HomeOutlined,
  MailOutlined,
} from "@ant-design/icons";

const { Header, Content, Footer } = Layout;

export default () => {
  return (
    <Footer>
      <Row align="middle" gutter={[0, 10]} justify="space-between">
        <Col lg={10}>
          <div
            className="logo"
            data-sal="slide-up"
            data-sal-duration="2000"
            data-sal-easing="ease-out-cubic"
          >
            <img className="logo_footer" alt="logo" src="/images/logo.png" />
          </div>
          <Row>
            <p>
              CERIS - Civil Engineering Research and Innovation for
              Sustainability
            </p>
          </Row>
          <Row gutter={[3, 0]}>
            <Col>
              <HomeOutlined />
            </Col>
            <Col>
              <address>Av. Rovisco Pais, 1049-001 Lisboa,Portugal</address>
            </Col>
          </Row>
          <Row>
            <p>
              <PhoneOutlined /> +351 218419709
            </p>
          </Row>
          <Row>
            <p>
              <MailOutlined /> jose.silvestre@tecnico.ulisboa.pt
            </p>
          </Row>
        </Col>

        <Col lg={{ span: 10 }}>
          <Row>
            <a
              href="https://www.eeagrants.gov.pt/pt/"
              target="_blank"
              className="link_image_footer"
            >
              <img
                src="/images/logos_footer/EEA_grants.png"
                className="image_footer"
              />
            </a>
          </Row>
        </Col>
      </Row>
      <Row justify="center">
        <Col>
          <p>&copy; 2022 - CplusD</p>
        </Col>
      </Row>
    </Footer>
  );
};
